import { Typography } from 'antd';
import { StyledIconWithTitle } from './IconWithTitle.styled';
import ActivityTypeIcon from '../ActivityTypeIcon/ActivityTypeIcon';
import { pxToVw } from '@/modules/styled/cssUnits';

const { Title } = Typography;

export default function IconWithTitle({ title, subTitle, type, iconColor }) {
  return (
    <StyledIconWithTitle>
      <div className="icon">
        <ActivityTypeIcon
          type={type}
          color="white"
          withCircle
          circleColor={iconColor}
          size={pxToVw(15)}
          className="activity-icon-class"
        />
      </div>
      <div className="title-wrapper">
        <Title level={1} className="title">
          {title}
        </Title>
        <Title level={2} className="sub-title">
          {subTitle}
        </Title>
      </div>
    </StyledIconWithTitle>
  );
}
